let RouterRepository = {
    ctx: '/ui/insu',
    get contextPath(){
        return this.ctx;
    },

    get local(){

        return location.origin + this.ctx;
    },
    get localTest(){
        return this.local + "/resources/data/test/";
    },
    get adminApi(){
        return this.local+ '/api/admin';
        // return this.gate_way + '/api/admin'
    },
    get authServer(){
        return this.local + '/auth';
    },
    get cert(){
        return this.local + '/api/cert';
        // return this.gate_way + '/cert'
    },
    get openApi() {
        return this.local + '/openapi';
    },
    get insu(){
        return this.local + '/api/insu';
        // return this.gate_way + '/cert'
    },
    get push(){
        return this.local + '/api/push';
    },
    get auth(){
        let authServer = this.authServer;
        return {
            getToken: this.local + '/rest/auth/login',
            deleteToken: this.local + '/rest/auth/logout',
            refreshToken: this.local + '/rest/auth/refreshToken',
            logout: this.local +'/rest/auth/logout' ,
            redirect: this.local + '/rest/auth/logout'
        };
    },
    get coin(){
        return this.local + '/claim';
    },
    get claim(){
        return this.local + '/claim';
    },
    get cheongshin(){
        return location.origin + '/cheongshin/api';
    }
}
let REST_API_CONFIG = {
    BASE_URL: RouterRepository.adminApi,
    TEST_DIR:  RouterRepository.localTest
}


let RXJS_AJAX_CONFIG = {
    timeout: 120000
}

export {RouterRepository, REST_API_CONFIG, RXJS_AJAX_CONFIG}
